import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { ThisPlatform } from "src/app/_services/platform.service";

@Component({
  selector: "app-info-tile",
  templateUrl: "./info-tile.component.html",
  styleUrls: ["./info-tile.component.scss"],
})
export class InfoTileComponent {
  constructor(public p: ThisPlatform, private router: Router) {}

  @Input()
  info;

  onAddElement($event, addEndpoint) {
    $event.preventDefault();
    $event.stopPropagation();
    this.router.navigate([addEndpoint]);
  }
}
